import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/_base/base.component';
import { SchoolBasicInformation, SchoolUserTypeDetail, SystemUserType } from 'src/app/_models';
import { Lookup } from 'src/app/_models/lookup.interface';
import { AcademicYearsLookup } from 'src/app/_models/system-setting/academic-year-manage/academic-years-lookup.interface';
import { LookUpService, SchoolService, UserService } from 'src/app/_services';
import { MainFiltersInterface } from 'src/app/_services/main-filters.service';

import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-main-filter',
  templateUrl: './main-filter.component.html',
  styleUrls: ['./main-filter.component.scss']
})
export class MainFilterComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {
  @Output() currentUserTypesEmitter = new EventEmitter<SystemUserType[]>();
  @Output() selectedUserTypeIdEmitter = new EventEmitter<number>();
  @Input() isHidden: boolean = false;
  @ViewChild('loading')
  loading: SpinnerComponent;
  companyId: number = 1;
  selectedAcademicSemesterId: number = null;
  educationalProgram: any[] = [];
  selectedSchoolId: number = null;
  schoolsList: SchoolBasicInformation[] = [];
  avaliableProgram: Lookup[] = [];
  academicPrograms: Lookup[] = [];
  selectedAcademicYearId: number = null;
  selectedAcademicProgramId: number;
  changeSelection: boolean = false;
  acadimcYears: AcademicYearsLookup[] = [];
  // logged in User Schools
  loggedInUserSchools: SchoolUserTypeDetail[] = [];
  selectEdeducationalProgramId: number = null;
  currentUserTypes: SystemUserType[] = [];
  selectedUserTypeId: number;
  isActive: boolean = false;
  schoolAddedSubscription: Subscription;
  constructor(private lookupSvc: LookUpService, private _schoolService: SchoolService, private _userService: UserService) {
    super();
    this.AcadmicYearsSvc.notifier.subscribe(() => {
      this.getacadimcYears();
    });
  }

  ngOnInit() {
    this.getAcademicPrograms();
    this.getAllSchool();
    this.getacadimcYears();
    this.schoolAddedSubscription = SchoolService.schoolAdded$.subscribe(() => {
      this.getAllSchool();
    });
  }
  ngOnDestroy() {
    if (this.schoolAddedSubscription) this.schoolAddedSubscription.unsubscribe();
  }
  ngAfterViewInit() {
    BaseComponent.spinner = this.loading;
  }
  getAcademicPrograms() {
    this.lookupSvc.getAcademicPrograms().subscribe((data: Lookup[]) => {
      this.academicPrograms = data;
      this.resetFilter();
    });
  }
  // get all school
  getAllSchool() {
    this._schoolService.getSchoolsBasicInformation(this.companyId).subscribe((data: SchoolBasicInformation[]) => {
      if (data.length > 0) {
        this.schoolsList = data;
      }
    });
  }
  getacadimcYears(): any {
    this.isActive = true;
    this.AcadmicYearsSvc.getAllLookups().subscribe(
      (data: AcademicYearsLookup[]) => {
        if (data.length > 0) {
          this.acadimcYears = data;
          this.selectedAcademicYearId = data[0].academicYearId;
          this.selectedAcademicSemesterId = data[0].academicSemesters[0].academicSemesterId;
          this.mainFilterSvc.sendMainFilter({
            // countryId: null,
            programId: null,
            academicYearId: this.selectedAcademicYearId,
            academicSemesterId: this.selectedAcademicSemesterId,
            schoolId: null
          });
          this.getDefaultSchoolForLoggedInUser();
        }
        this.isActive = false;
      },
      () => {
        this.isActive = false;
      }
    );
  }
  getDefaultSchoolForLoggedInUser() {
    const currentLoggedinUserSchools = localStorage.getItem('schools');
    if (currentLoggedinUserSchools) {
      this.loggedInUserSchools = JSON.parse(currentLoggedinUserSchools);
      if (this.loggedInUserSchools.length > 0) {
        const selectedSchool = this.loggedInUserSchools.filter(i => i.isDefault)[0];
        // to do
        const oldFilter = JSON.parse(localStorage.getItem('filterObj'));
        if (oldFilter) {
          return;
        }
        this.selectedSchoolId = selectedSchool.schoolId;
        this.selectedAcademicProgramId = selectedSchool.programIds[0];
        this.getUserTypesInSelectedSchool();
        this.getEducationalPrograms();
        this.mainFilter.programId = this.selectedAcademicProgramId;
        this.mainFilter.schoolId = this.selectedSchoolId = selectedSchool.schoolId;
        this.mainFilterSvc.sendMainFilter(this.mainFilter);
      }
    }
  }
  // get user types for user in selected school
  getUserTypesInSelectedSchool() {
    if (this._userService.isAdmin()) {
      return true;
    }
    this.currentUserTypes = [];
    this.isActive = true;
    this._userService.getUserTypesBySchoolUserId(this._userService.getLoggedInUserInformation().id, this.selectedSchoolId).subscribe(
      (data: SystemUserType[]) => {
        this._userService.setRoles([]);
        if (data.length > 0) {
          this.currentUserTypes = data;
          this.selectedUserTypeId = data[0].systemUserTypeId;

          // to do select first user type and set active roles
          this._userService.getListRolesNameByUserTypeId(this.currentUserTypes[0].systemUserTypeId).subscribe((roleData: string[]) => {
            this._userService.setRoles(roleData);
          });
          this.currentUserTypesEmitter.emit(this.currentUserTypes);
          this.selectedUserTypeIdEmitter.emit(this.selectedUserTypeId);
        }
        this.isActive = false;
      },
      () => {
        this.isActive = false;
      }
    );
    this.currentUserTypesEmitter.emit(this.currentUserTypes);
    this.selectedUserTypeIdEmitter.emit(this.selectedUserTypeId);
  }
  getEducationalPrograms() {
    this.educationalProgram = [];
    if (!this.selectedSchoolId) {
      return (this.educationalProgram = []);
    }
    const avaliableProgramIds = this.schoolsList.find(f => f.schoolId === this.selectedSchoolId).academicProgramIds;
    this.avaliableProgram = [];
    this.academicPrograms.map(value => {
      if (avaliableProgramIds.find(f => f === value.id)) this.avaliableProgram.push(value);
    });
    this.lookupSvc.getEducationalProgramBySchoolId(this.selectedSchoolId).subscribe((data: any[]) => {
      this._schoolService.GetEducationalProgramsBySchoolId(this.selectedSchoolId).subscribe((Activedata: any[]) => {
        this.educationProgramsFormatter(data, Activedata);
      });
    });
  }
  mainFilterChanged() {
    if (this.changeSelection) {
      this.changeSelection = false;
      this.selectedAcademicYearId = this.getIdByselectedSemester();
      const filterObj: MainFiltersInterface = {
        programId: this.selectedAcademicProgramId === 1 ? 1 : 2,
        schoolId: this.selectedSchoolId || null,
        academicYearId: this.selectedAcademicYearId || null,
        academicSemesterId: this.selectedAcademicSemesterId || null,
        educationalProgramId: this.selectEdeducationalProgramId || null
      };
      // to do
      localStorage.setItem('filterObj', JSON.stringify(filterObj));
      this.mainFilterSvc.sendMainFilter(filterObj);
      this.getUserTypesInSelectedSchool();
    }
  }
  resetFilter() {
    this.changeSelection = false;
    const oldFilter = JSON.parse(localStorage.getItem('filterObj'));
    if (oldFilter) {
      this.isActive = true;
      this.lookupSvc.getSchoolAndEducation(oldFilter.programId, oldFilter.schoolId, this.companyId).subscribe(
        data => {
          this.schoolsList = data[0] as SchoolBasicInformation[];
          this.academicChanged({ value: oldFilter.programId });
          this.educationProgramsFormatter(data[1] as any[], data[1] as any[]);
          this.selectedAcademicProgramId = oldFilter.programId;
          this.selectedSchoolId = oldFilter.schoolId;
          this.schoolChanged();
          this.selectedAcademicYearId = oldFilter.academicYearId;
          this.selectEdeducationalProgramId = oldFilter.educationalProgramId;
          this.selectedAcademicSemesterId = oldFilter.academicSemesterId;
          this.isActive = false;
          setTimeout(() => {
            this.mainFilterSvc.sendMainFilter(oldFilter);
            this.getUserTypesInSelectedSchool();
          }, 100);
        },
        () => {
          this.isActive = false;
        }
      );
    } else {
      this.selectedAcademicProgramId = null;
      this.selectedSchoolId = null;
      this.selectedAcademicYearId = null;
      this.selectEdeducationalProgramId = null;
      this.selectedAcademicSemesterId = null;
    }
    this.getDefaultSchoolForLoggedInUser();
  }
  schoolChanged() {
    this.selectedAcademicSemesterId = null;
    this.getEducationalPrograms();
  }
  academicChanged(event) {
    this.educationalProgram = [];
    this.selectEdeducationalProgramId = null;
    // comment by shamasneh cause this property will be reset auto
    this.selectedSchoolId = null;
    this.selectedAcademicSemesterId = null;
  }

  educationProgramsFormatter(educationalPrograms: any[], Activedata: any[]) {
    const parentPrograms = educationalPrograms.filter(
      e => e.parentId == null && (Activedata.findIndex(f => f.id === e.id) !== -1 || e.academicProgramId === 2)
    );

    const childs = educationalPrograms.filter(e => e.parentId != null);
    if (childs) {
      for (const parentProgram of parentPrograms)
        parentProgram.subPrograms = childs.filter(c => c.parentId === parentProgram.id && Activedata.findIndex(f => f.id === c.id) !== -1);
    }
    this.educationalProgram = parentPrograms.filter(f => f.subPrograms.length !== 0 || f.academicProgramId === 1);
  }
  changeSelect() {
    // this.selectedAcademicSemesterId =0;
    this.selectedAcademicYearId = this.getIdByselectedSemester();
    if (this.selectedAcademicProgramId && this.selectedSchoolId && this.selectedAcademicSemesterId && this.selectedAcademicYearId) {
      this.changeSelection = true;
    } else {
      this.changeSelection = false;
    }
  }
  getIdByselectedSemester(): any {
    let id = 0;
    this.acadimcYears.forEach(value => {
      value.academicSemesters.forEach(v => {
        if (v.academicSemesterId === this.selectedAcademicSemesterId) {
          id = value.academicYearId;
        }
      });
    });
    return id;
  }
  isAuthorizeSchool(schoolId: number) {
    if (this._userService.isAdmin()) {
      return true;
    }
    if (this.loggedInUserSchools.length > 0 && this.schoolsList.length > 0) {
      return (
        this.loggedInUserSchools.filter(i => i.schoolId === schoolId && i.programIds.indexOf(this.selectedAcademicProgramId) > -1).length >
        0
      );
    }
  }
  educationalProgramChangeSelect() {
    this.selectedAcademicSemesterId = null;
    if (this.educationalProgram.find(f => f.id === this.selectEdeducationalProgramId))
      this.selectedAcademicProgramId = this.educationalProgram.find(f => f.id === this.selectEdeducationalProgramId).academicProgramId;
    else this.selectedAcademicProgramId = 2;
  }
  isAuthorizeAcademicProgram(programId: number) {
    if (this._userService.isAdmin()) {
      return true;
    }
    if (this.loggedInUserSchools.length > 0 && this.schoolsList.length > 0) {
      return this.loggedInUserSchools.filter(i => i.programIds.indexOf(programId) > -1).length > 0;
    }
  }
  isInterNatoinal() {
    return this.avaliableProgram.findIndex(f => f.id === 2) !== -1;
  }
}
